(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("BillingInformationCtrl", ["accountsResource", "myAccountResource", "tenantResource", "globalizationService", "messageService", "profileRecord", "$state", "$translate", "$scope", "_", billingInformationCtrl]);
    function billingInformationCtrl(accountsResource, myAccountResource, tenantResource, globalizationService, messageService, profileRecord, $state, $translate, $scope, _) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        var person = $state.params.personSeq;
        vm.profileRecord = profileRecord;
        var billingInfo = profileRecord.selfRegistrationEnabledFields.billingInformation.value;
        vm.model = {
            addressLine1: billingInfo ? billingInfo.addressLine1 : "",
            addressLine2: billingInfo ? billingInfo.addressLine2 : "",
            city: billingInfo ? billingInfo.city : "",
            postalCode: billingInfo ? billingInfo.zipPostalCode : "",
            provinceId: billingInfo ? billingInfo.stateProvinceId : null,
            countryId: billingInfo ? billingInfo.countryId : null
        };
        tenantResource.getCountriesList(function (data) {
            vm.dataLoaded = true;
            vm.countryList = data.countries;
            vm.updateProvinceList(true);
        }, function (error) {
            messageService.error(error);
        });
        vm.updateProvinceList = function (firstLoad) {
            var countryObj = _.find(vm.countryList, { id: vm.model.countryId });
            if (countryObj) {
                globalizationService.load(countryObj.threeLetterISOCode, function (result) {
                    vm.stateProvinceLabel = result.stateProvinceLabel;
                    vm.postalZipLabel = result.postalZipLabel;
                    vm.postalZipRegex = new RegExp(result.postalZipRegex);
                    vm.postalZipPattern = result.postalZipPattern;
                    vm.postalZipMask = result.postalZipMask;
                });
                vm.provinceList = countryObj.provinces;
            }
            if (!firstLoad || vm.model.provinceId === 0) {
                vm.model.provinceId = null;
            }
        };
        vm.translateName = function (name, isCountry) {
            if (isCountry)
                return $translate.instant("common.country." + name.replace(/\s+/g, ""));
            return $translate.instant("common.stateProvince." + name.replace(/\s+/g, ""));
        };
        vm.save = function (isValid) {
            vm.saving = true;
            if (isValid) {
                var billingInfoBindingModel = {
                    id: profileRecord.id,
                    addressLine1: vm.model.addressLine1,
                    addressLine2: vm.model.addressLine2,
                    city: vm.model.city,
                    postalCode: vm.model.countryId ? vm.model.postalCode : null,
                    provinceId: vm.model.provinceId ? vm.model.provinceId : 0,
                    countryId: vm.model.countryId ? vm.model.countryId : 0
                };
                if ($state.current.name === "main.myAccount") {
                    myAccountResource.updateMyAddressInformation({ personSeq: person }, billingInfoBindingModel, function () {
                        messageService.success("account.profile.edit.billingInformation.success");
                        $scope.$close({ postalCodeLabel: vm.postalZipLabel, provinceLable: vm.stateProvinceLabel });
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else {
                    accountsResource.updateBillingInformation({ personSeq: person }, billingInfoBindingModel, function () {
                        messageService.success("account.profile.edit.billingInformation.success");
                        $scope.$close({ postalCodeLabel: vm.postalZipLabel, provinceLable: vm.stateProvinceLabel });
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
            }
            else {
                vm.showErrors = true;
                vm.saving = false;
            }
        };
    }
}());
